export enum TrackerType {
  IMAGE= 1,
  ELEVATION
}
